<template>
  <div class="justify-content-md-center" style="margin-top:5%;">
    <h1> Mise à jour des cartes de <br> {{selectedReference}} </h1>
    <b-row style="margin-top:5%;">
        <b-col sm="6">
            <h4 style="color: red;"> Fournisseur introuvable ? </h4>
        </b-col>
        <b-col sm="6">
        <b-button
            size="sm"
            variant="primary"
            @click="addNewSupplier()"
            class="mr-2"
        >
            Ajouter un fournisseur
        </b-button>
        </b-col>
    </b-row>
     <b-table style="margin-top:5%;" striped hover :items="cardsItem" :fields="detailsFields">
         <template v-slot:cell(Supplier)="row">
            <model-select :options="supplierList"
                          v-model="selectedSupplier[row.item.card_id]"></model-select>
        </template>
     </b-table>
     <b-button
        size="sm"
        variant="primary"
        @click="updateCardsSupplier()"
        class="mr-2"
    >
        Mettre à jour
    </b-button>
    <AddSupplierModal ref="add-supplier"/>
  </div>
</template>

<script>

import server from '../../api/server.vue'
import { ModelSelect } from 'vue-search-select'
import AddSupplierModal from './AddSupplierModal.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'UpdateCardInfos',
  props: [],
  data () {
    return {
        selectedReference: '',
        cardsItem: [],
        selectedSupplier: [],
        supplierList: [],
        detailsFields: [
        { key: 'card_id', sortable: true },
        { key: 'card_index', sortable: true },
        { key: 'supplier.supplier', label: 'Fournisseur', sortable: true },
        { key: 'Supplier', label: 'Changer de fournisseur'}
      ],

    }
  },
  computed: {
    ...mapGetters(['actualLoop']),
  },
  methods: {
      getCardsFromReference () {
        const loop = this.actualLoop ==  'loop_external' ? this.actualLoop : 'loop_usual_components';
        server.getKanbanCardByReference(this.selectedReference, loop).then(response => {
          console.log(JSON.stringify(response.data, null, 2))
          this.cardsItem = response.data
        }).catch(e => console.error(e))
      },
      addNewSupplier () {
        this.$refs['add-supplier'].showModal()
      },
      updateCardsSupplier() {
          for (const [key, value] of Object.entries(this.selectedSupplier)) {
              server.updateCardSupplier({'supplier': value, 'card_id': key}).then(() => {
                  this.getCardsFromReference()
              })
          }
          this.makeToast("MaJ réussie !")
      },
      getSupplierList() {
          server.getAllSupplier().then((result) => {
              result.data.forEach(element => {
                  this.supplierList.push({'value': element.supplier, 'text': element.supplier})
              });
          })
      }

  },
  mounted: function () {
    this.selectedReference = this.$route.params.reference

    this.getCardsFromReference()
    this.getSupplierList()
  },
  components: { ModelSelect, AddSupplierModal }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/supply/UpdateCardInfos.vue